/**
 * Utility functions for company data
 */

/**
 * Parse companyURL and return the first URL from semicolon-separated list
 */
export function getFirstCompanyUrl(companyURL?: string): string | null {
  if (!companyURL) return null;
  
  const urls = companyURL.split(';').map(url => url.trim()).filter(Boolean);
  return urls.length > 0 ? urls[0] : null;
}

/**
 * Extract YouTube video ID from URL
 */
export function extractYouTubeVideoId(url?: string): string | null {
  if (!url) return null;
  
  // Handle various YouTube URL formats
  const patterns = [
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\n?#]+)/,
    /youtube\.com\/watch\?.*v=([^&\n?#]+)/,
  ];
  
  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match && match[1]) {
      return match[1];
    }
  }
  
  return null;
}



